export class ExportChannel {
  id?: number;
  code?: string;
  name?: string;
  label?: string;
  usesCodifiedUses?: boolean;

  constructor(init?: Partial<ExportChannel>) {
    Object.assign(this, init);
  }
}
